export default {
  FAQRoot: 'FAQ-root',
  FAQButtonWrapper: 'faq-button-wrapper',
};
